import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { EmpresaResponse } from '../../responses/usuario/empresa.response';

@Injectable({
  providedIn: 'root',
})
export class GetEmpresaService extends CommonService {
  constructor(private httpClient: HttpClient) {
    super();
  }

  private readonly apiUrl = `${environment.urlApiUsuario}GetEmpresa/`;

  public obterPorId(idEmpresa: number): Observable<EmpresaResponse> {
    return this.httpClient
      .get<EmpresaResponse>(
        `${this.apiUrl}idEmpresa/${idEmpresa}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}

